import { Button, EmptyState } from '@clara/ui'
import { useT } from '@clara/locale'
import { Flex } from '@clara/ui'

export const ErrorFallbackGlobal = () => {
  const { t } = useT('common')
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <EmptyState
        imageUrl={
          'https://clara-all-assets-prod.s3.us-east-1.amazonaws.com/help-center/no-results.svg'
        }
        headline={t('global.error.emptystate.title')}
        tagline={t('global.error.emptystate.description')}
        primaryAction={
          <Button
            variant="primary"
            onClick={() => {
              window.location.href = '/'
            }}
          >
            {t('global.error.emptystate.action')}
          </Button>
        }
      />
    </Flex>
  )
}
